import Header from "../Header/Header";
import "./Error404.css";

function Error404() {
  return <Header />;
}

export default Error404;
